import { API_ENDPOINTS } from "../config/api.config";
import apiClient from "../utils/apiClient";

const adminPubMedIngestService = {
  preview(pmid) {
    return apiClient.post(API_ENDPOINTS.ADMIN.PUBMED_PREVIEW, { pmid });
  },

  ingest(pmid) {
    return apiClient.post(API_ENDPOINTS.ADMIN.PUBMED_INGEST, { pmid });
  },

  delete(pmid) {
    return apiClient.delete(API_ENDPOINTS.ADMIN.PUBMED_DELETE(pmid));
  },
};

export default adminPubMedIngestService;
